import React from "react";

import Text from "src/components/text";

import styles from "./topDealsCard.module.scss";
import { ClosedDealItem } from "src/types/reports";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

interface ClosedDealsCardProps {
  item: ClosedDealItem;
}

const ClosedDealsCard: React.FC<ClosedDealsCardProps> = ({ item }) => {
  const { id, name, icon, shares, opportunities } = item;

  return (
    <a
      href={`/assets/${id}?source=reports`}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.linkWrapper}
    >
      <div className={styles.card}>
        <img
          src={icon?.thumbnail || DefaultAssetIcon}
          alt={name}
          className={styles.thumbnailIcon}
        />
        <div className={styles.content}>
          <Text text={name || ""} className={styles.title} lines={1} />
          <div className={styles.metrics}>
            <span>{shares || 0} Interactions</span>
            <span>{opportunities || 0} Deals</span>
          </div>
        </div>
      </div>
    </a>
  );
};

export default ClosedDealsCard;
